<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <forwarding-address-form v-if="isInitialized" v-bind="formData" @stored="onStored"></forwarding-address-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import ForwardingAddressForm from '../../components/forwarding-address/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      ForwardingAddressForm,
    },

    computed: {
      /**
       * @return {boolean}
       */
      modelExists() {
        return _.has(this.formData, 'model.id');
      },

      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (this.modelExists) {
          return 'Edit Forwarding Address';
        }

        return 'Create Forwarding Address';
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-forwarding-address-table');
      },
    },

    created() {
      eventBus.$on('show-forwarding-address-form-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-forwarding-address-form-dialog', this.show);
    }
  }
</script>
